import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CommandPaletteService {
	private open$ = new Subject<void>();

	get openRequested$() {
		return this.open$.asObservable();
	}

	open(): void {
		this.open$.next();
	}
}
